import type { ReactNode } from "react";

import NotFound from "@/NotFound";
import PermissionGate from "@/permission/components/PermissionGate";
import { PROVIDER_PERMISSION_FLAGS } from "@/permission/constants/practitioner-permissions";

interface ProviderAmendmentGateProps {
  children: ReactNode;
}

export default function ProviderAmendmentGate({ children }: ProviderAmendmentGateProps) {
  return (
    <PermissionGate
      allowPatient={false}
      fallback={<NotFound />}
      requiredPermissions={PROVIDER_PERMISSION_FLAGS}
    >
      {children}
    </PermissionGate>
  );
}
